import { useState } from "react";
import { UseFormSetValue } from "react-hook-form";
import { intl } from "LocaleWrapper";
import { Button, FormGroup } from "@cofano/cck";
import { Box } from "@mui/material";
import { ProductPickerDialog } from "components/products/ProductPicker";
import { Language } from "utils";
import { ProductFormFields, ProductTypes } from "view/products/utils/product.types";
import { ProductSchemaInput } from "view/products/utils/product.schema";
import { NstrGoodFragment } from "__generated__/view/products/graphql/product.fragments.generated";

interface ProductNSTRGoodProps {
	product: ProductFormFields | null;
	nstrGoods: NstrGoodFragment[];
	setValue: UseFormSetValue<ProductSchemaInput>;
}

const ProductNSTRGood = ({ product, nstrGoods, setValue }: ProductNSTRGoodProps) => {

	const [ nstrGood, setNstrGood ] = useState(product?.nstrGood);
	const [ dialogOpen, setDialogOpen ] = useState(false);

	return nstrGood ? (
		<div>
			<Box sx={{ alignItems: "center", display: "flex", justifyContent: "space-between" }}>
				<FormGroup label={Language("PRODUCTS_NSTR_CODE")} overflow="hidden">
					{nstrGood.nstrCode || "-"}
				</FormGroup>

				<Button
					onClick={() => {
						setNstrGood(undefined);
						setValue("productNSTRGoodId", undefined);
						setValue("nstrCode", undefined);
					}}
					size="small"
					color="danger">
					{intl.formatMessage({ id: "LOCATION_UNLINK_CUSTOMER" })}
				</Button>
			</Box>

			<FormGroup label={Language("PRODUCT_NSTR_CARGO_GROUP")} overflow="hidden">
				{nstrGood.cargoGroup || "-"}
			</FormGroup>

			<FormGroup label={Language("PRODUCT_NSTR_DISCHARGE_IN_WATERWAY")} overflow="hidden">
				{nstrGood.dischargingInWaterway || "-"}
			</FormGroup>

			<FormGroup label={Language("PRODUCT_NSTR_DISCHARGE_IN_SEWERS")} overflow="hidden">
				{nstrGood.dischargingInSewers || "-"}
			</FormGroup>

			<FormGroup label={Language("PRODUCT_NSTR_SPECIAL_TREATMENT")} overflow="hidden">
				{nstrGood.specialTreatment || "-"}
			</FormGroup>

			<FormGroup label={Language("PRODUCT_NSTR_REMARK")} overflow="visible">
				{nstrGood.remark || "-"}
			</FormGroup>
		</div>
	) : (
		<div>
			<Button onClick={() => setDialogOpen(true)}>Add NSTR</Button>

			<ProductPickerDialog
				open={dialogOpen}
				onClose={() => setDialogOpen(false)}
				onChange={good => {
					setNstrGood(good);
					setValue("nstrCode", good?.nstrCode || undefined);
					setValue("productNSTRGoodId", good?.id || undefined);
				}}
				type={ProductTypes.NSTR}
				list={nstrGoods} />
		</div>
	);
};

export default ProductNSTRGood;
